module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('p', {
    staticClass: "p-c-br"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("‘Where is the Prince who can afford so to cover his country")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("with troops for its defense, as that 10,000 men descending")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("from the clouds, might not, in many places, do an infinite")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("deal of mischief before a force could be brought together to")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("repel them?")])]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Benjamin Franklin 1784")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d6c5aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783468874_fm01.vue
// module id = 72
// module chunks = 0